export const ZONE_BLOCKER_AUCTION_SCHEDULED_OR_LIVE = 'zone.blocker.auctionScheduledOrLive';
export const ZONE_BLOCKER_MEMBER_HAS_ZONE = 'zone.blocker.assignedToMember';
export const ZONE_BLOCKER_USER_HAS_FORBIDDEN_ZONE = 'zone.blocker.forbiddenToUser';
export const ZONE_BLOCKER_USED_IN_AUCTION = 'zone.blocker.usedInAuction';
export const ZONE_BLOCKER_AUCTION_RUNNING_OR_CLOSED = 'zone.blocker.auctionRunningOrClosed';

export const transformZoneBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case ZONE_BLOCKER_AUCTION_SCHEDULED_OR_LIVE:
            result = t('zones.blocker.auction-scheduled-or-live');
            break;
        case ZONE_BLOCKER_MEMBER_HAS_ZONE:
            result = t('zones.blocker.member-has-zone');
            break;
        case ZONE_BLOCKER_USER_HAS_FORBIDDEN_ZONE:
            result = t('zones.blocker.user-has-forbidden-zone');
            break;
        case ZONE_BLOCKER_USED_IN_AUCTION:
            result = t('zones.blocker.used-in-auction');
            break;
        case ZONE_BLOCKER_AUCTION_RUNNING_OR_CLOSED:
            result = t('zones.blocker.auction-running-or-closed');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
